import { conjugatePresentWithFathaPrefixesFromPast } from './arPresentFromPastFatha';

function isBinyan5(row) {
  const binyan = String(row?.['בניין'] || row?.binyan || '').trim();
  return binyan === '5' || binyan === 'בניין 5';
}

export function conjugatePresentFormV_Salim(verb3ms) {
  return conjugatePresentWithFathaPrefixesFromPast(verb3ms);
}

export function conjugatePresentFormV_Salim_fromRow(row) {
  if (!isBinyan5(row)) return null;
  return conjugatePresentFormV_Salim(row?.['פועל'] || row?.lemma3ms || '');
}
